export default {
    modal: state => state.modal,
    current: state => state.current,
    clientPayments: state => state.clientPayments,
    paymentsAppearance: state => state.paymentsAppearance,
    paymentsLoading: state => state.paymentsLoading,
    isLoading: state => state.isLoading
}
